module.exports = __webpack_public_path__ + "CH.png?68bdac0b6a8c08dc7140ee30c9be96f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/CH.png
// module id = 338
// module chunks = 0